<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
  >
    <a-select-option
      v-for="item in records"
      :key="item.moduleType"
      :title="item.moduleName"
      :value="item.moduleType"
    >
      {{ item.moduleName }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, PropType, ref } from "vue";
import { ProcessConfigService } from "@/views/process-manage/process-config/process-config.service";

/**
 * 审批业务类型选择器
 *
 * 使用方式:
 * <ApprovalModuleTypeSelect v-model:value="formRef.moduleType"></ApprovalModuleTypeSelect>
 */
export default defineComponent({
  isGlobal: true,
  name: "ApprovalModuleTypeSelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "请选择业务模块",
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    const onChange = async (id) => {
      emit("update:value", id);
      emit("change", id);
    };

    const { data: records, run, loading } = ProcessConfigService.useModuleTypeApi();
    onMounted(async () => {
      await run();
    });

    return {
      records,
      onChange,
      loading,
    };
  },
});
</script>
